<div class="mb-4 mx-4 mx-md-0 d-flex align-items-center justify-content-between">
  <h2 class="semi-bold">Payment details</h2>

  <ng-container *ngIf="clientBalanceAmount && clientBalanceAmount > 0">
    <div
      *ngIf="isSplittedPayment$ | async; else splitTemplate"
      (click)="merge()"
      class="d-flex align-items-center px-md-4 cursor-pointer"
    >
      <img src="assets/icons/merge.svg" alt="merge" />
      <p class="caption ml-2">Back to Single Payment</p>
    </div>

    <ng-template #splitTemplate>
      <div (click)="split()" class="d-flex align-items-center px-md-4 cursor-pointer">
        <img src="assets/icons/split.svg" alt="split" />
        <p class="caption ml-2">Split between two methods</p>
      </div>
    </ng-template>
  </ng-container>
</div>

<ds-info-block *ngIf="isSplittedPayment$ | async" class="mb-3"
  >Your payment will be split between two methods.</ds-info-block
>

<div class="d-flex flex-column">
  <form [formGroup]="form">
    <formly-form [form]="form" [fields]="fields" [model]="model" />
  </form>

  <div *ngIf="form.touched && form.errors" class="d-none d-md-block">
    @for (error of form.errors | keyvalue; track error.key) {
      <form-error [error]="error" class="mt-4" data-id="error" />
    }
  </div>
</div>

<div class="d-md-none p-fixed form-errors">
  <div *ngIf="form.touched && form.errors" class="mx-4">
    @for (error of form.errors | keyvalue; track error.key) {
      <form-error [error]="error" class="mb-2" data-id="error" />
    }
  </div>
</div>

<ng-content />

<div class="mt-md-8 mx-4 mx-md-0 d-flex flex-column-reverse flex-md-row">
  <ds-button
    label="Back"
    variant="secondary"
    leadingIcon="chevronLeft"
    (click)="back.emit()"
    [fullWidth]="true"
    class="mt-4 mt-md-0 w-md-unset"
    data-id="back"
  />

  <ds-button
    label="Pay and confirm"
    (click)="submit()"
    [disabled]="form.disabled"
    [fullWidth]="true"
    class="ml-md-auto w-md-unset"
    data-id="submit"
  />
</div>
